module.exports = __webpack_public_path__ + "img/post-layout.60476136.png";